module.exports = __webpack_public_path__ + "static/media/Yoga.d42024f7.svg";